<div class="table-layout">
    <div class="table-operation">
        <button nButton id="client-nfs-share-refresh" style="float: right;" icon="icon-refresh" (click)="refresh()">
        </button>
        <n-button-group [relateTable]="dt" [items]="[addBtn, removeBtn]">
        </n-button-group>
    </div>
    <div class="table-container">
        <n-data-table #dt id="client-nfs-share-table" style="height: 4rem;"  [config]="tableConfig" [columnDefs]="tableColumnDefs"
            [rest]="tableRest" [countRest]="tableCountRest" [(selection)]="selection" [simpleMode]="isSimpleMode">
        </n-data-table>
    </div>
</div>
